import set from 'lodash/fp/set';
import unset from 'lodash/fp/unset';
import formAnswersReducer from './formAnswers';

export default function(state, action) {
    if (!state) {
        return {
            metadata: {},
            drafts: {},
            uploading: [],
        };
    }

    let previous = state;
    switch (action.type) {
        case 'FORM_LOAD_PERSISTED_DATA':
            // NOTE: if format changes, do the migration before it gets here :)
            state.metadata = action.payload.data.metadata || {};
            state.drafts = _(action.payload.data.drafts || {}).reduce((drafts, answer, UID) => {
                drafts[UID] = formAnswersReducer(answer, {
                    forceRevalidation: true,
                    metadata: state.metadata[answer.formId],
                });
                return drafts;
            }, {});
            state.uploading = action.payload.data.uploading || [];
            _(state.metadata).each((metadata, formId) => {
                metadata.uptodate = false;
            });
            break;
        case 'FORM_LOAD_METADATA':
            state = set(
                `metadata[${action.formId}]`,
                Object.assign({}, action.metadata, {
                    uptodate: true,
                    groups: _(action.metadata.groups)
                        .sortBy('position')
                        .map(group =>
                            Object.assign({}, group, {
                                questions: _(group.questions)
                                    .sortBy('position')
                                    .map(question =>
                                        Object.assign({}, question, {
                                            enable_condition: question.enable_condition ? JSON.parse(question.enable_condition) : null,
                                            options: _(question.options)
                                                .map(option =>
                                                    Object.assign({}, option, {
                                                        enable_condition: option.enable_condition ? JSON.parse(option.enable_condition) : null,
                                                    })
                                                )
                                                .sortBy('position')
                                                .value(),
                                        })
                                    )
                                    .value(),
                                proceed_condition: group.proceed_condition ? JSON.parse(group.proceed_condition) : null,
                            })
                        )
                        .value(),
                }),
                state
            );
            state.drafts = _(state.drafts || {}).reduce((drafts, answer, UID) => {
                if (answer.formId == action.formId) {
                    drafts[UID] = formAnswersReducer(answer, {
                        forceRevalidation: true,
                        metadata: action.metadata,
                    });
                } else {
                    drafts[UID] = answer;
                }
                return drafts;
            }, {});
            break;
        case 'FORM_CREATE_RESPONSE':
            state = set(
                `drafts.${action.answerUID}`,
                formAnswersReducer(
                    _(state).get(`drafts.${action.answerUID}`),
                    Object.assign({}, action, {
                        forceRevalidation: true,
                        metadata: state.metadata[action.formId],
                    })
                ),
                state
            );
            break;
        case 'FORM_DELETE_ANSWER_INSTANCE':
            state = unset(`drafts.${action.answerUID}`, state);
            break;
        case 'FORM_SEND_ANSWER':
            if (state.drafts[action.answerUID]) {
                state = set(`uploading`, [...state.uploading, state.drafts[action.answerUID]], state);
                state = unset(`drafts.${action.answerUID}`, state);
            } else {
                console.error('Unknown form answer to upload: ', action.answerUID);
            }
            break;
        case 'FORM_SET_ANSWER_VALUE':
            if (state.drafts[action.answerUID]) {
                let draft = _(state).get(`drafts.${action.answerUID}`);
                state = set(
                    `drafts.${action.answerUID}`,
                    formAnswersReducer(
                        draft,
                        Object.assign(
                            {
                                metadata: state.metadata[draft.formId],
                            },
                            action
                        )
                    ),
                    state
                );
            } else {
                console.warn('Attempting to change unknown form answer');
            }
            break;
        case 'FORM_UPLOAD_SUCCESS':
            state = set(
                `uploading`,
                _(state.uploading)
                    .reject(answer => answer.UID == action.answerUID)
                    .value(),
                state
            );
            break;
    }

    return state;
}
